// must live in top level to be accessible in this folder and children
var ailtire = new Object();
